import script from "./LanguageSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageSwitch.vue?vue&type=style&index=0&id=ed0f7676&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed0f7676"]])

export default __exports__